import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function AutopaySuccessPage() {
  const nav = useNavigate();
  const params = new URLSearchParams(useLocation().search);
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ state: "checking" });

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/autopay/session/${sessionId}`);
        if (data.active) { setStatus({ state: "active" }); return; }
        if (attempts > 12) { setStatus({ state: "pending" }); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts > 12) { setStatus({ state: "failed" }); return; }
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-8">
      <Card className="max-w-md w-full p-8 text-center">
        {status.state === "checking" && (
          <>
            <Loader2 className="h-10 w-10 mx-auto animate-spin text-zinc-400" />
            <div className="mt-4 font-medium">Activating autopay…</div>
          </>
        )}
        {status.state === "active" && (
          <>
            <CheckCircle2 className="h-12 w-12 mx-auto text-emerald-500" />
            <div className="mt-4 text-2xl font-semibold font-display">Autopay is on</div>
            <div className="text-sm text-muted-foreground mt-1">Your monthly HOA dues will now be charged automatically. You can cancel anytime.</div>
            <Button onClick={() => nav("/resident/pay")} className="mt-6 rounded-full">Manage autopay</Button>
          </>
        )}
        {status.state !== "checking" && status.state !== "active" && (
          <>
            <div className="text-lg font-medium">Setup didn&apos;t complete.</div>
            <div className="text-sm text-muted-foreground mt-1">You can try again from the payment page.</div>
            <Button onClick={() => nav("/resident/pay")} className="mt-6 rounded-full">Back to payments</Button>
          </>
        )}
      </Card>
    </div>
  );
}
